import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';
/**
 * @ignore - internal component.
 */

export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/internal/svg-icons/Warning.js
// module id = 1639
// module chunks = 121